// DS: C35
import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MobileSubmissionDetails from './MobileSubmissionDetails';
import DesktopSubmissionDetails from './DesktopSubmissionDetails';

export interface Props {
  deviation: PapiDeviation;
  isOwner: boolean;
  showTitle?: boolean;
  className?: string;
}

const SubmissionDetails: React.FC<Props> = props => {
  const isMobile = useContext(MobileContext);

  return isMobile ? (
    <MobileSubmissionDetails {...props} />
  ) : (
    <DesktopSubmissionDetails {...props} />
  );
};
SubmissionDetails.displayName = 'SubmissionDetails';

export default SubmissionDetails;
